// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"94d82fb1","77":"a74d03a4","115":"a66fb7a3","222":"a9aee63f","280":"898499c7","354":"92c158cb","444":"f9db5d39","523":"15167719","526":"38ecd3f3","567":"04345ebb","850":"5a3b4af5","860":"6939893a","928":"d979bf35"}[chunkId] + ".chunk.js";
};